/* istanbul ignore file */

import { makeFragmentData } from '@packages/gql/generated/shopping';
import {
  SelectValuesFragmentFragmentDoc,
  type SelectValuesFragmentFragment,
} from '@packages/gql/generated/shopping/graphql';
import deepmerge from 'deepmerge';

export const selectDimensionDataMock: SelectValuesFragmentFragment = {
  displayName: 'Color',
  values: [
    {
      rgb: '000',
      displayText: 'black - not selected - no availability data',
      sku: '1',
      image: 'https://bilder.baur.de/i/empiriecom/e2024bb057b29bca39b5e9dc8445bd66.jpg',
      variationMainImage: null,
      isSelected: false,
      availability: null,
    },
    {
      rgb: 'eee',
      displayText: 'offwhite - selected - available',
      sku: '2',
      image: 'https://bilder.baur.de/i/empiriecom/4f05f51d0f43fc418cdb047082992b56.jpg',
      variationMainImage:
        'https://bilder.baur.de/i/empiriecom/02fb599211b5e2c7293db1de938315df.jpg',
      isSelected: true,
      availability: {
        state: 'AVAILABLE',
        message: 'next day delivery',
      },
    },
    {
      rgb: null,
      displayText:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit.  - not selected - not available',
      sku: null,
      image: null,
      variationMainImage: null,
      isSelected: false,
      availability: {
        state: 'NOT_AVAILABLE',
        message: 'out of stock',
      },
    },
  ],
};
export const selectDimensionDataMockManyValues = deepmerge(selectDimensionDataMock, {});
selectDimensionDataMockManyValues.values.concat([
  {
    displayText: 'gelb',
    image: 'https://bilder.baur.de/i/empiriecom/ae313398fd8e175eda64be8716915b67',
    variationMainImage: null,
    isSelected: false,
    rgb: 'FF0',
    sku: '8711923547',
    availability: {
      state: 'AVAILABLE',
      message: 'next day delivery',
    },
  },
  {
    displayText: 'grün',
    image: 'https://bilder.baur.de/i/empiriecom/87f691dab51fc061fa8617480d0d8e29',
    variationMainImage: null,
    isSelected: false,
    rgb: '32DC32',
    sku: '5655903487',
    availability: {
      state: 'AVAILABLE',
      message: 'next day delivery',
    },
  },
  {
    displayText: 'koralle',
    image: 'https://bilder.baur.de/i/empiriecom/88804ab2361f1070025546f1bd3ca1bb',
    variationMainImage: null,
    isSelected: true,
    rgb: 'FFA500',
    sku: '4797554157',
    availability: {
      state: 'AVAILABLE',
      message: 'next day delivery',
    },
  },
  {
    displayText: 'lila',
    image: 'https://bilder.baur.de/i/empiriecom/ee318eb05c9d72daf42bd0dbc6c8e8a0',
    isSelected: false,
    rgb: '9370D8',
    sku: '9640575948',
    variationMainImage: 'https://bilder.baur.de/i/empiriecom/70355f005a399972e4c53f2970f1ffbf.jpg',
    availability: {
      state: 'AVAILABLE',
      message: 'next day delivery',
    },
  },
  {
    displayText: 'mint',
    image: 'https://bilder.baur.de/i/empiriecom/166ecacb763def28137ab107e37d98bb',
    variationMainImage: null,
    isSelected: false,
    rgb: '32DC32',
    sku: '6032834687',
    availability: {
      state: 'AVAILABLE',
      message: 'next day delivery',
    },
  },
  {
    displayText: 'navy',
    image: 'https://bilder.baur.de/i/empiriecom/b43dcf240c83702e41ca487555c819cc',
    variationMainImage: null,
    isSelected: false,
    rgb: '000080',
    sku: '2679774455',
    availability: {
      state: 'AVAILABLE',
      message: 'next day delivery',
    },
  },
  {
    displayText: 'schwarz',
    image: 'https://bilder.baur.de/i/empiriecom/26b6b3b0f1cddc57e4f2616c7548219e',
    variationMainImage: null,
    isSelected: false,
    rgb: '000',
    sku: '7697774729',
    availability: {
      state: 'AVAILABLE',
      message: 'next day delivery',
    },
  },
  {
    displayText: 'türkis',
    image: 'https://bilder.baur.de/i/empiriecom/15e858e016cb4e8b4a7204bf7e371281',
    variationMainImage: null,
    isSelected: false,
    rgb: '000080',
    sku: '7115066159',
    availability: {
      state: 'AVAILABLE',
      message: 'next day delivery',
    },
  },
  {
    displayText: 'weiß',
    image: 'https://bilder.baur.de/i/empiriecom/17525f410dda1568053c6ae5445df00f',
    variationMainImage: null,
    isSelected: false,
    rgb: 'FFF',
    sku: '4893580382',
    availability: {
      state: 'NOT_AVAILABLE',
      message: 'out of stock',
    },
  },
]);

export const selectDimensionDataMockWithoutColors = deepmerge(selectDimensionDataMock, {});
selectDimensionDataMockManyValues.values.map((value) => ({
  ...value,
  image: null,
  rgb: null,
  variationMainImage: null,
}));

export function getSelectDimensionFragmentedData(data?: SelectValuesFragmentFragment) {
  return makeFragmentData(data || selectDimensionDataMock, SelectValuesFragmentFragmentDoc);
}
